module.exports = __webpack_public_path__ + "static/lang4ulogo-4307ac2a0f00fd193eb6df8b213c6436.png";